import * as React from 'react';

interface IPageWrapperViewProps {
  children: JSX.Element;
  titleDiv: JSX.Element;
  overflowY: any;
  paddingTop: string;
  paddingBottom: string;
}

interface IPageWrapperViewState {}

export default class PageWrapperView extends React.Component<IPageWrapperViewProps, IPageWrapperViewState> {
  render() {
    let { children, titleDiv, overflowY, paddingTop, paddingBottom } = this.props;
    return (
      <div
        className="row flexWrapper margin0 generalBackground"
        style={{ position: 'relative', height: '100%', padding: '0' }}
      >
        {titleDiv}
        <div
          className="rightPanelDetails"
          style={{ overflowY: overflowY, paddingTop: paddingTop, paddingBottom: paddingBottom }}
        >
          {children}
        </div>
      </div>
    );
  }
}
